import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SubmissionService {
  private readonly SUBMISSION_KEY = 'formSubmitted';
  private emailKey = 'buyerEmail';

  setBuyerEmail(email: string) {
    localStorage.setItem(this.emailKey, email);
  }
  getBuyerEmail(): string {
    return localStorage.getItem(this.emailKey) || '';
  }
  clearSubmissionemailStatus() {
    localStorage.removeItem(this.emailKey);
  }
  setFormSubmitted(status: boolean) {
    sessionStorage.setItem(this.SUBMISSION_KEY, JSON.stringify(status));
  }
  isFormSubmitted(): boolean {
    return JSON.parse(sessionStorage.getItem(this.SUBMISSION_KEY) || 'false');
  }
  clearSubmissionStatus() {
    sessionStorage.removeItem(this.SUBMISSION_KEY);
  }
}
